<template>
  <div
    class="opple-secret-platform"
  >
    <div
      class="opple-secret-platform_row"  
    >
      <div
        class="opple-secret-platform_label"
      >
        {{ $t('adddevice.secret') }}
        <!-- // enocean面板中继密钥 去掉问号显示 -->
        <!-- <div
          class="opple-secret-platform_label_icon"
        >
          ?
          <img :src="$img('enocean2')">
        </div> -->
      </div>
      <div
        class="opple-secret-platform_container"
      >
        <el-input
          v-model="passwordVal"
          :type="isShowPassword ? 'text' : 'password'"
          class="opple-secret-platform_ipt"
          @change="onPassWordChange(val)"
        />
        <div
          class="opple-secret-platform_eye"
          @click="triggerShowPassword"
        >
          <img
            :src="isShowPassword ? seenImg : unseenImg"
          >
        </div>
      </div>
    </div>
    <div
      class="opple-secret-platform_saveBtn"
      @click="requestSave"
    >
      {{ $t('addThirdDevice.save') }}
    </div>
  </div>
</template>
<script>
import {
  SetConfigs,
} from '@/axios/IDevice.js';
import seenImg from '@/assets/img/eye_open.png';
import unseenImg from '@/assets/img/eye_close.png';
import { isEquealBytes } from '@/utils/str';
import { alerterror, alertsuccess, success, warning } from '@/assets/js/common.js'

export function isMidSecretConfig (config) {
  const GpDetails = config.GpDetails || [];
  
  return !!GpDetails.find(item => item.KeyId === 223);  
}

export default {
  name: 'Secret',
  components: {

  },
  props: {
    device: {
      type: Object,
      default: () => ({})
    },
    gpList: {
      type: Array,
      default: () => ([]) 
    }
  },
  data() {
    return {
      passwordVal: '',
      isShowPassword: false,
      seenImg,
      unseenImg
    };
  },

  computed: {},

  watch: {
    gpList() {
      this.initPassWord();
    }
  },

  mounted() {
    this.initPassWord();
  },

  methods: {
    initPassWord() {
      const GpDetails = this.gpList[0].GpDetails || [];
      // console.log('this.gpList', this.gpList, devices);
      const SecretData = GpDetails.find(item => item.KeyId === 223) || {};
      console.log('SecretData.DefaultValue', SecretData.DefaultValue);

      this.passwordVal = SecretData.DefaultValue;
    },
  
    onPassWordChange(val) {
      console.log('val', val);
    },

    async requestSave() {
      if (!isEquealBytes(this.passwordVal, 32)) {
        this.$message({
          type: 'warning',
          message: this.$t('adddevice.requires32characters')
        })
        return;
      }

      try {
        const params = {
          VDeviceId: this.device.VDeviceId,
          GpNo: this.device.Gpno, 
          ConfigItems: [{
            Key: 223,
            Values: [this.passwordVal]
          }]
        };

        const res = await SetConfigs(params);

        if (res.StatusCode == this.$store.state.rightStatusCode) {
          alertsuccess(this, res.StatusCode);
          this.doFindConfigAbility(1);
        } else {
          alerterror(this, res.StatusCode);
        }
      } catch (e) {}
    },

    triggerShowPassword() {
      this.isShowPassword = !this.isShowPassword;
    }
  },
};
</script>

<style lang="scss">
.opple-secret-platform {
  position: relative;
  flex: 1;
  padding: 10px 40px 10px 0;
  height: 200px;

  &_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &_eye {
    position: absolute;
    right: 60px;
    top: 10px;
    cursor: pointer;
  }

  &_ipt {
    position: relative;
    width: 220px;
  }

  &_label {
    display: flex;
    align-items: center;

    &_icon {
      position: relative;
      width: 16px;
      height: 16px;
      margin-left: 10px;
      line-height: 16px;
      text-align: center;
      border: 1px solid #999;
      border-radius: 50%;
      color: #999;
      cursor: pointer;

      &:hover {
        img {
          display: block;
        }
      }
    }

    img {
      display: none;
      position: absolute;
      width: 800px;
      left: 29px;
      top: -231px;
      // top: 0;
      z-index: 10;
      background: #fff;
      border: 1px solid #eee;
      // border: 1px solid #999;
      // box-shadow: 10px 10px 10px rgba(0, 0, 0, .1);
    }
  }

  &_saveBtn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    color: #0246AB;
    border: 1px solid #0246AB;
    width: 257px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      color: #fff;
      background-color: #0246AB;
    }
  }
}

</style>
